import Helper from '@ember/component/helper';
import { type Registry as Services, service } from '@ember/service';
import Model from '@ember-data/model';

export default class IsRouteActiveHelper extends Helper {
  @service router!: Services['router'];

  compute([route, model]: [string, Model]): boolean {
    const currentRouteName = this.router.currentRouteName ?? '';

    if (!currentRouteName) {
      return false;
    }

    if (model) {
      return this.router.isActive(route, model);
    }

    return currentRouteName.startsWith(route);
  }
}
